/**
 * Toast 组件 JavaScript
 * 提供动态显示toast消息的功能
 */

// 全局Toast函数
window.showToast = function(message, type = 'normal', duration = 5000, extraClass) {
  const localizedMessage = window.localizeFrontendText ? window.localizeFrontendText(message) : message;

  // 如果消息是"Operation completed successfully."，不显示
  if (
    localizedMessage === 'Operation completed successfully.' ||
    (window.getFrontendMessage && localizedMessage === window.getFrontendMessage('operationCompletedSuccessfully'))
  ) {
    return;
  }
  
  const toast = document.getElementById('toast');
  const toastMessage = document.getElementById('toastMessage');
  
  if (!toast || !toastMessage) {
    console.error('Toast elements not found');
    return;
  }
  
  const prevExtraClass = toast.dataset.extraClass;
  if (prevExtraClass) {
    toast.classList.remove(prevExtraClass);
    toast.dataset.extraClass = '';
  }

  toastMessage.textContent = localizedMessage;
  
  toast.classList.remove('component-toast--normal', 'component-toast--error');
  
  toast.classList.add(`component-toast--${type}`);
  if (extraClass) {
    toast.classList.add(extraClass);
    toast.dataset.extraClass = extraClass;
  }
  
  // 显示toast
  toast.classList.add('component-toast--show');
  
  // 自动隐藏
  setTimeout(() => {
    toast.classList.remove('component-toast--show');
  }, duration);
};

// 隐藏toast的函数
window.hideToast = function() {
  const toast = document.getElementById('toast');
  if (toast) {
    toast.classList.remove('component-toast--show');
  }
};

// 页面加载完成后初始化
document.addEventListener('DOMContentLoaded', function() {
  // 确保toast元素存在
  const toast = document.getElementById('toast');
  if (!toast) {
    console.warn('Toast element not found in DOM');
  }
}); 
